export default {
  RESET_ERROR_MESSAGE: 'RESET_ERROR_MESSAGE'
}
